import React, { useCallback, useEffect, useState } from 'react';
import AdminErrorBoundary from './AdminErrorBoundary';
import AdminLoginPrompt from './AdminLoginPrompt';
import adminOperationsService from '../../services/adminOperationsService';

const AdminRoute = ({ children }) => {
  const [status, setStatus] = useState('checking');

  const verify = useCallback(async () => {
    setStatus('checking');
    const user = await adminOperationsService.verifySession();
    setStatus(user ? 'authorized' : 'login');
  }, []);

  useEffect(() => {
    verify();
    const expire = () => setStatus('login');
    window.addEventListener('admin-session-expired', expire);
    return () => window.removeEventListener('admin-session-expired', expire);
  }, [verify]);

  if (status === 'checking') {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-950 text-slate-200">
        <div className="text-center">
          <div className="mx-auto h-10 w-10 animate-spin rounded-full border-2 border-slate-700 border-t-cyan-400" />
          <p className="mt-4 text-sm text-slate-400">Verifying admin session…</p>
        </div>
      </div>
    );
  }

  if (status === 'login') return <AdminLoginPrompt onSuccess={() => setStatus('authorized')} />;

  return <AdminErrorBoundary>{children}</AdminErrorBoundary>;
};

export default AdminRoute;
